import { getUSPData } from './api.js';
const getConsentState = async () => {
    const uspData = await getUSPData();
    const optedOut = uspData.uspString.charAt(2) === "Y";
    return {
        personalisedAdvertising: !optedOut
    };
};
export { getConsentState };
